import Button from '../Button/Button';
import './Navbar.css'
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from 'react-router';
import { LoginButton } from '../LoginButton/LoginButton';

function Navbar() { 
    const { isAuthenticated } = useAuth0();


    return (
        <div className="navBody">
            <div className="navRight">
                
                
            </div>

            <div className="navLeft">
                <LoginButton />
                {isAuthenticated && (
                    <Link to="/profile">My Profile</Link>
                )}
            </div>
            
            

        </div>
    )
    
}
export default Navbar;